export default "__VITE_ASSET__BGHdx0Eo__"